/* eslint-disable */
import React, { useState, useEffect } from 'react';
import '../WeeklyClosureReport/clouserReport.scss';
import DataGridComponent from '../../../../Components/DataGrid/dataGrid';
import DateRangeEditor from '../../../../Components/CustomDateRange/dateRangeInput';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ButtonComponent from '../../../../Components/Button/button';
import { useSnackbar } from '../../../../Components/Snackbar/snackBarProvider';
import ArrowDropDown from '../../../../Assets/images/svg/drop-down-arrow.svg';
import excelIcon from '../../../../Assets/images/svg/excel.svg';
import excelHoverIcon from '../../../../Assets/images/svg/excel_hover.svg';
import {
  CLOUSER_REPORT,
  PENDING_ONBOARDING,
  DATE_NOTE_HEADING,
  DATE_NOTE_DESCRIPTION,
} from '../../../../Constants/strings';
import { defaultDateRanges } from '../defaultDate';

const ResourcesPendingOnboarding = ({
  onDateChange,
  onboardingData,
  onDownloadExcel,
  dateRange,
  setDateRange,
}) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 1024);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isExcelHovered, setIsExcelHovered] = useState(false);
  const { snackbarOpen } = useSnackbar();

  const handleResize = () => {
    setIsMobileView(window.innerWidth < 1024);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDateRangeChange = (newDateRange) => {
    const { startDate, endDate } = newDateRange;

    const parsedStartDate = startDate ? new Date(startDate) : null;
    const parsedEndDate = endDate ? new Date(endDate) : null;

    if (parsedStartDate && isNaN(parsedStartDate)) {
      console.error('Invalid startDate in handleDateRangeChange:', startDate);
      return;
    }

    if (parsedEndDate && isNaN(parsedEndDate)) {
      console.error('Invalid endDate in handleDateRangeChange:', endDate);
      return;
    }

    setDateRange({ startDate: parsedStartDate, endDate: parsedEndDate });

    if (parsedStartDate && parsedEndDate) {
      onDateChange(parsedStartDate, parsedEndDate);
    }
  };

  const handleDownloadClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const handleDownloadExcel = async () => {
    if (!dateRange?.startDate || !dateRange?.endDate) return;
    const result = await onDownloadExcel(dateRange.startDate, dateRange.endDate);
    if (!result.success) {
      snackbarOpen(PENDING_ONBOARDING.DOWNLOAD_FAILURE_MESSAGE, PENDING_ONBOARDING.ERROR_SEVERITY);
    }
    handleCloseMenu();
  };

  const generateColumns = () => {
    const baseProps = { sortable: false, disableColumnMenu: true };
    const mobileWidth = {
      CUSTOMER: 140,
      DEAL_TYPE: 120,
      GEOGRAPHY: 120,
      VERTICAL: 100,
      LOCATION: 120,
      NO_OF_POSITIONS: 160,
      DETAILS: 120,
      SALES_TEAM_MEMBER: 185,
      DELIVERY_MANAGER: 170,
    };

    const fields = [
      'CUSTOMER', 'DEAL_TYPE', 'GEOGRAPHY', 'VERTICAL',
      'LOCATION', 'NO_OF_POSITIONS', 'DETAILS',
      'SALES_TEAM_MEMBER', 'DELIVERY_MANAGER',
    ];

    return fields.map((key) => ({
      field: PENDING_ONBOARDING.FIELDS[key],
      headerName: CLOUSER_REPORT.HEADER[key] || PENDING_ONBOARDING.HEADER[key],
      ...(isMobileView ? { width: mobileWidth[key] } : { flex: 1 }),
      ...baseProps,
    }));
  };

  const columns = generateColumns();
  const sortFilterColumns = columns.map(({ field }) => field);

  return (
    <div className="closure-report-outer-layer">
      <div className="closure-report">
        <div className="closure-top-section">
          <div className="closure-date-filter">
            <DateRangeEditor
              key={`resource-pending-date-range-${dateRange.startDate}-${dateRange.endDate}`}
              dateRange={{
                startDate: dateRange.startDate ? new Date(dateRange.startDate) : null,
                endDate: dateRange.endDate ? new Date(dateRange.endDate) : null,
              }}
              onChange={(newDateRange) => handleDateRangeChange(newDateRange)}
              fromPlaceholder="From Date"
              toPlaceholder="To Date"
              dateFormat="dd/mm/yyyy"
              definedRanges={defaultDateRanges}
              useCurrentYear
              splitInitialCustomMonthView={true}
            />
            <div className="staff-aug-date-range-note">
              <strong className="staff-aug-date-heading">{DATE_NOTE_HEADING}</strong>{' '}
              {DATE_NOTE_DESCRIPTION}
            </div>
          </div>
          <div>
            <ButtonComponent
              label="Download"
              variant="text"
              onClick={handleDownloadClick}
              endIcon={<img alt="Arrow Down" src={ArrowDropDown} />}
              btnCss="download-skill-btn"
            />
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
              <MenuItem
                onClick={handleDownloadExcel}
                className="download-dropdown"
                onMouseEnter={() => setIsExcelHovered(true)}
                onMouseLeave={() => setIsExcelHovered(false)}
              >
                <img
                  src={isExcelHovered ? excelHoverIcon : excelIcon}
                  alt="Excel Icon"
                  style={{ marginRight: 8 }}
                />
                Download as Excel
              </MenuItem>
            </Menu>
          </div>
        </div>

        <div className="closure-report-grid-container">
          <DataGridComponent
            dataRows={onboardingData}
            dataColumns={columns}
            sortFilterColumns={sortFilterColumns}
            pageSize={onboardingData?.length || 10}
            isEdit={false}
            dataGridCss="closure-report-grid"
            isBackendPaginated={false}
            hideFooter
            hideSeparator
          />
        </div>
      </div>
    </div>
  );
};

export default ResourcesPendingOnboarding;
